export const DRAW = 'DRAW';
export const END_DRAW = 'END_DRAW';
/** The deck being dragged onto the hand, to draw (Drag/dropTargets setDragging). */
export const DECK_TO_HAND = 'deck-to-hand';
